import React from 'react';
import { Like, Views, Visits } from 'src/shared/design-system/ShefSocial/Icons';
import { PostViewsAndVisitsProps } from '../../../types';
import { Container, CountContainer } from './styles';

export const ViewsAndVisits: React.FC<PostViewsAndVisitsProps> = (props) => {
  const { clickCount, numLikes, showLikes, showViews, showVisits, viewCount } = props;
  return (
    <Container>
      {showViews && (
        <CountContainer>
          <Views />
          {viewCount ?? 0}
        </CountContainer>
      )}
      {showLikes && (
        <CountContainer>
          <Like />
          {numLikes ?? 0}
        </CountContainer>
      )}
      {showVisits && (
        <CountContainer>
          <Visits />
          {clickCount ?? 0}
        </CountContainer>
      )}
    </Container>
  );
};
